import { Flex } from 'components/Flex/Flex';
import styled from 'styled-components';

export {
  SectionLabel,
  ShiftCardList,
  ShiftCardWrapper,
  ShiftIdText,
  PositionText,
  CardText,
} from 'modals/ShiftModal/components/ShiftBlockOrdersList/ShiftBlockOrdersList.styled';

export const Heading = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 28px;
  line-height: 34px;
  margin: 0;
`;

export const Description = styled.p`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  line-height: 21px;
  margin: 0;
`;

export const JaneCard = styled(Flex)`
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.Grey1};
`;

export const JaneName = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  line-height: 24px;
`;

export const JaneCommunity = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-size: 14px;
  line-height: 21px;
`;
